import React from 'react';
import { FiX, FiTrash2, FiAlertTriangle } from 'react-icons/fi';

const DeleteConfirmationModal = ({ isOpen, closeModal, userToDelete, handleDeleteConfirm }) => {
  if (!isOpen || !userToDelete) return null;
  
  // Handler for clicking outside modal content
  const handleBackdropClick = (e) => {
    if (e.target.className === 'modal-backdrop') {
      closeModal();
    }
  };
  
  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content delete-modal" style={{ maxWidth: '400px' }}>
        <div className="modal-header">
          <h3><FiAlertTriangle style={{ marginRight: '10px' }} /> Confirmar Exclusão</h3>
          <button className="modal-close" onClick={closeModal}>
            <FiX />
          </button>
        </div>
        
        <div className="delete-modal-content">
          <div className="delete-warning-icon">
            <FiAlertTriangle size={48} />
          </div>
          
          <div className="delete-warning-text">
            <p className="delete-warning-title">
              Tem certeza que deseja excluir o usuário <strong>{userToDelete.username || userToDelete.name}</strong>?
            </p>
            <p className="delete-warning-subtitle">
              Esta ação não pode ser desfeita e todos os dados do usuário serão permanentemente removidos.
            </p>
          </div>
        </div>
        
        <div className="modal-footer">
          <button
            type="button"
            className="configuracoes-btn configuracoes-btn-secondary"
            onClick={closeModal}
            style={{ backgroundColor: '#3E5F56', color: 'white' }}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="configuracoes-btn configuracoes-btn-primary delete-btn"
            style={{ backgroundColor: '#d32f2f' }}
            onClick={handleDeleteConfirm}
          >
            <FiTrash2 style={{ marginRight: '8px' }} />
            Excluir
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;